export default __webpack_public_path__ + "static/media/2.0569a66b.svg";